import { useMutation, useQueryClient } from '@tanstack/react-query';

import {
	createEmailTemplate,
	updateEmailTemplate,
	deleteEmailTemplate,
	uploadEmailTemplateAttachment,
	deleteEmailTemplateAttachment,
} from '../../api/emailTemplatesApi';

import { emailTemplatesKeys } from './keys';

export function useCreateEmailTemplate() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: createEmailTemplate,
		onSuccess: () => qc.invalidateQueries({ queryKey: emailTemplatesKeys.all }),
	});
}

export function useUpdateEmailTemplate() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ id, payload }) => updateEmailTemplate(id, payload),
		onSuccess: () => qc.invalidateQueries({ queryKey: emailTemplatesKeys.all }),
	});
}

export function useDeleteEmailTemplate() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: deleteEmailTemplate,
		onSuccess: () => qc.invalidateQueries({ queryKey: emailTemplatesKeys.all }),
	});
}

export function useUploadEmailTemplateAttachment() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: ({ templateId, file }) => uploadEmailTemplateAttachment(templateId, file),
		onSuccess: () => qc.invalidateQueries({ queryKey: emailTemplatesKeys.all }),
	});
}

export function useDeleteEmailTemplateAttachment() {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: deleteEmailTemplateAttachment,
		onSuccess: () => qc.invalidateQueries({ queryKey: emailTemplatesKeys.all }),
	});
}
